import { Box, IconButton, Typography } from "@mui/material";
import { RemoveCircleOutline } from "@mui/icons-material";
import {
  textStyles,
  formsItemWrapper,
  deleteIconButton,
} from "@features/formAssignments/FormsWrapperItemStyles";
import { useAppDispatch } from "@hooks/useTypedRedux";
import { openModal } from "@features/modals/genericModalSlice";
import { ConfirmationModal } from "@features/modals/ConfirmationModal";
import { IFormAssignmentForm } from "../../../../types/formAssignments/IInOfficeEvent";
import { FormModalStyles } from "../../../../features/modals/FormModalStyles";

interface FormsWrapperItemProps {
  form: IFormAssignmentForm;
  onDeleteForm?: (formId: number) => void;
}

export const FormsWrapperItem = ({
  form,
  onDeleteForm,
}: FormsWrapperItemProps) => {
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(
      openModal({
        component: ConfirmationModal,
        props: {
          title: "Delete Form?",
          body: (
            <>
              <Typography sx={FormModalStyles.script}>
                Are you sure you want to delete this form?
              </Typography>
              <Typography sx={FormModalStyles.description}>
                {form.name}
              </Typography>
            </>
          ),
          confirmLabel: "Yes, Delete",
          cancelLabel: "No, Go Back",
          onConfirm: () => {
            if (onDeleteForm) {
              onDeleteForm(form.id);
            }
          },
        },
      })
    );
  };

  return (
    <Box sx={formsItemWrapper}>
      {onDeleteForm && (
        <IconButton sx={deleteIconButton} onClick={handleDelete}>
          <RemoveCircleOutline />
        </IconButton>
      )}
      <Typography sx={textStyles}>{form.name}</Typography>
    </Box>
  );
};
